import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class ResiService {

  clearDateRange = new Subject();

  constructor(private api: ApiService) {
  }

  calculateRawTotals(properties) {
    const keys = [
      { resi: 'total_price', property: 'price' },
      { resi: 'total_size', property: 'total_area' },
    ];
    const totals = {};
    keys.map(key => {
      totals[key.resi] = 0;
      properties.map(property => {
        if (property) {
          totals[key.resi] += Number(property[key.property]);
        }
      });
    });
    return totals;
  }

  getMultipleBuyers(resiId) {
    return this.api.get(`/api/transactions/resi/${resiId}/multiple_buyers/`).pipe(
      map(response => {
        if (response && response.mul_buyers) {
          return response.mul_buyers;
        }
      }));
  }

  addBuyer(resiId) {
    return this.api.post(`/api/transactions/resi/${resiId}/multiple_buyers/`, {});
  }

  updateBuyer(resiId, buyerDetails) {
    return this.api.put(`/api/transactions/resi/${resiId}/multiple_buyers/${buyerDetails.id}/`, buyerDetails);
  }

  deleteBuyer(resiId, buyerId) {
    return this.api.delete(`/api/transactions/resi/${resiId}/multiple_buyers/${buyerId}/`);
  }

  getPropertyCountForBuyer(resiId, buyerId) {
    return this.api.get(`/api/transactions/resi/${resiId}/multiple_buyers/${buyerId}/`)
      .pipe(map(response => {
        return response;
      }));
  }

  getPropertiesForBuyers(resiId) {
    return this.api.get(`/api/transactions/resi/${resiId}/get_properties/`)
      .pipe(map(response => {
        return response;
      }));
  }

  associatePropertyToBuyer(resiId, buyerId, propertyId) {
    return this.api.post(`/api/transactions/resi/${resiId}/multiple_properties/`, {
      'property_id': propertyId,
      'buyer_id': buyerId
    }).pipe(map(response => {
      return response;
    }));
  }

  deletePropertyBuyerAssociation(resiId, propertyId) {
    return this.api.delete(`/api/transactions/resi/${resiId}/multiple_properties/${propertyId}/`);
  }

  clearDateRangeFilter(isClear) {
    this.clearDateRange.next(isClear);
  }

  bulkConfidentialUpdate(bulkConfidentialData: any): Observable<any> {
    return this.api.put(`/api/transactions/resi/bulk_confidential_update/`, bulkConfidentialData);
  }

  bulkCustomerUpdate(bulkCustomerData: any): Observable<any> {
    return this.api.put(`/api/transactions/resi/bulk_customer_update/`, bulkCustomerData);
  }

  getResiProjects(projectName: string, transactionStatus: string) {
    const resiProjectsUrl = `/api/transactions/resi-projects?project_name=${projectName}&status=${transactionStatus}`;
    return this.api.get(resiProjectsUrl)
      .pipe(
        map(response => response)
      );
  }

  setResiProjectFilter(filter_project: { label: string; value: string }): void {
    window.localStorage.setItem('resi_filter_project', JSON.stringify(filter_project));
  }

  getResiProjectFilter(): { label: string; value: string } {
    if (window.localStorage.getItem('resi_filter_project')) {
      return JSON.parse(window.localStorage.getItem('resi_filter_project'));
    }
    return null;
  }

}
